import {
    getPlace,
    getStart,
    getEnd,
} from './searchLenses'
import isPlaceEqual from 'commons/js/util/isPlaceEqual'

export default function isSearchEqual (search, otherSearch) {
    return isPlaceEqual(getPlace(search), getPlace(otherSearch)) &&
        getStart(search) === getStart(otherSearch) &&
        getEnd(search) === getEnd(otherSearch)
}
